import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { BASE_URL } from "../constants";

/**
 * Public route used for dashboard-style open links (same host as DASHBOARD_APP_URL).
 * Mail clients use the API pixel URL directly; this page is for browser tests and optional links.
 */
export default function EmailOpenTrackPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!token) {
      navigate("/", { replace: true });
      return;
    }

    const pixel = new Image();
    pixel.src = `${BASE_URL}/track/email/open/${encodeURIComponent(token)}`;

    const redirectTimer = window.setTimeout(() => {
      navigate("/", { replace: true });
    }, 400);

    return () => window.clearTimeout(redirectTimer);
  }, [token, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-paper px-4">
      <p className="text-sm text-muted">Opening your dashboard…</p>
    </div>
  );
}
